import cronstrue from 'cronstrue';

export function cronUserFriendly(cronCommand: string): string {
  return cronstrue.toString(cronCommand, {
    verbose: true,
  });
}
